import styled from 'styled-components';
import { DrawerItems } from '@/components/Drawer/Drawer.styles';

export const DrawerItem = styled(DrawerItems)`
  border-radius: 21px;
  padding: 20px 15px;
`;

export const RestoredAdDescription = styled.div`
  margin-bottom: 15px;
`;

export const PromotionTitle = styled.div`
  margin-bottom: 20px;
`;

export const AdNumber = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  border-radius: 7px;
  height: 39px;
  letter-spacing: 3px;
  font-size: 15px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.primary.labels};
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;
